import './shimmer.css';

/** Single shimmer placeholder block. */
export function ShimmerBlock({ className = '', style, as: Tag = 'div', ...rest }) {
  return <Tag className={`shimmer-block ${className}`.trim()} style={style} aria-hidden {...rest} />;
}

/** Text-line shimmer. */
export function ShimmerLine({ className = '', width = '100%', style, ...rest }) {
  return (
    <span
      className={`shimmer-line ${className}`.trim()}
      style={{ width, ...style }}
      aria-hidden
      {...rest}
    />
  );
}

/** Property listing card skeleton (grid cell). */
export function ListingCardSkeleton({ className = '' }) {
  return (
    <div className={`shimmer-card ${className}`.trim()} aria-hidden>
      <ShimmerBlock className="shimmer-card__media" />
      <div className="shimmer-card__body">
        <ShimmerLine width="72%" />
        <ShimmerLine width="48%" />
        <ShimmerLine width="88%" />
      </div>
    </div>
  );
}

/**
 * Grid of listing card skeletons — matches loc1-grid breakpoints.
 * @param {{ count?: number, className?: string }} props
 */
export default function ListingGridSkeleton({ count = 6, className = '' }) {
  return (
    <div
      className={`loc1-grid listing-grid-skeleton ${className}`.trim()}
      aria-busy="true"
      aria-label="Loading projects"
    >
      {Array.from({ length: count }).map((_, i) => (
        <ListingCardSkeleton key={i} />
      ))}
    </div>
  );
}
